import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MobileAppComponent } from './mobile-app.component';
import { mobileAppRoutes } from './mobile-app.routes';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [SharedModule, LayoutModule, RouterModule.forChild(mobileAppRoutes), TranslateModule],
  declarations: [MobileAppComponent],
  exports: [],
  entryComponents: [MobileAppComponent]
})
export class MobileAppModule {}
